import React from "react";
import { Text, Image, TouchableOpacity, View, Dimensions } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { s } from "react-native-size-matters";
import { AppImages } from "../../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Avatar from "./Avatar";

const AvatarComponent = ({ avatar, isSelected, onSelectionChange, styles }) => {
  const deviceSize = useDeviceSize();
  const screenWidth = Dimensions.get("window").width;

  // Calculate avatar width based on screen width to ensure 3 avatars per row on mobile
  const getAvatarWidth = () => {
    if (deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM) {
      // Use 28% of screen width to fit 3 avatars with gaps (3 * 28% = 84%, leaving 16% for padding/gaps)
      return Math.floor(screenWidth * 0.28);
    }
    return 128;
  };

  const avatarWidth = getAvatarWidth();

  return (
    <TouchableOpacity
      style={[
        {
          marginBottom: s(10),
          alignItems: "center",
          // Use flexBasis for reliable 3-per-row layout on mobile
          flexBasis: deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? '30%' : 'auto',
          maxWidth: deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? '30%' : 'auto',
        },
      ]}
      activeOpacity={0.8}
      onPress={() => onSelectionChange(!isSelected)} // Toggle selection
    >
      <View
        style={[
          {
            borderWidth: 1,
            borderColor: isSelected ? "#DC2626" : "transparent",
            backgroundColor: isSelected
              ? "rgba(220, 38, 38, 0.10)"
              : "transparent",
            borderRadius: 8,
            overflow: "hidden",
            width: '100%',
            height: 138,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            position: "relative",
          },
        ]}
      >
        <Avatar src={avatar.full} variant="largePlayer" />
        {isSelected && (
          <View
            style={{
              width: 15,
              height: 15,
              borderRadius: 50,
              backgroundColor: "#DC2626",
              position: "absolute",
              top: 8,
              right: 8,
            }}
          />
        )}
      </View>
    </TouchableOpacity>
  );
};

export default AvatarComponent;
